var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-nav", class: { "mini-nav": _vm.miniNav } },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-items" }, [
      _c("a", { staticClass: "nav-item", attrs: { href: "#" } }, [
        _vm._v("Terms of Use")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "nav-item", attrs: { href: "#" } }, [
        _vm._v("Protected content")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "nav-item", attrs: { href: "#" } }, [
        _vm._v("Price indications and other information")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "nav-item", attrs: { href: "#" } }, [
        _vm._v("Cookies")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "nav-item", attrs: { href: "#" } }, [
        _vm._v("What is an instructional price for electricity?")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "nav-item", attrs: { href: "#" } }, [
        _vm._v("Avoid directions and save money")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "nav-item", attrs: { href: "#" } }, [
        _vm._v("Compare electricity contracts and find the best agreement")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }